import { render, staticRenderFns } from "./FileUploader.vue?vue&type=template&id=2608c54e&scoped=true"
import script from "./FileUploader.vue?vue&type=script&lang=ts"
export * from "./FileUploader.vue?vue&type=script&lang=ts"
import style0 from "./FileUploader.vue?vue&type=style&index=0&id=2608c54e&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2608c54e",
  null
  
)

export default component.exports